<template>
  <div class="logo">
    <img src="/img/palladium_group.jpg" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.logo {
  width: 400px;
  height: 200px;
}

.logo img {
  width: 100%;
  height: 100%;
}
</style>
